import React from "react";
import Slider from "../components/Slider";
import ProductDetails from "../components/ProductDetails";

const Home = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Slider />
        </div>
        <div className="col-md-12">
          <div className="about-info mt-3">
            <h3>About Us</h3>
            <p>
              "SARTHI INFOTECH" has been founded by Mr.Anil Kamaliya (Director)
              & Er. Kamlesh Chudasama(Director) with his long term vision to
              provinde All IT And Electrical Solutions (CCTV Security solution ,
              home atomation , House wiring , Bio-Matrix solution , EPABX\/IP
              PBX system, networking , Fire alarm system , Online UPS , Wireless
              Solution And Audio & video solution) with their strong &
              experience team having more then 3 yrs expertise in the field.
            </p>
          </div>
        </div>
        <ProductDetails />
      </div>
    </div>
  );
};

export default Home;
